// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"85f5d50e","145":"e0ea5bd4","422":"671b309a"}[chunkId] + ".chunk.js";
};